import { RootState } from 'reducers/rootReducer';
import { useSelector } from 'react-redux';

const useEntitiesAreLoading = () => {
    return useSelector((state: RootState) => state.admin.loading > 0);
};
export default useEntitiesAreLoading;
